module.exports = __webpack_public_path__ + "img/symbol_8.63f90a76.png";